import { Model, RestSerializer, Server } from 'miragejs';
import { loginHandler, signupHandler } from './backend/controllers/AuthController';
import {
  addPostCommentHandler,
  deletePostCommentHandler,
  downvotePostCommentHandler,
  editPostCommentHandler,
  getPostCommentsHandler,
  upvotePostCommentHandler,
} from './backend/controllers/CommentsController';
import {
  createPostHandler,
  deletePostHandler,
  dislikePostHandler,
  editPostHandler,
  getAllUserPostsHandler,
  getAllpostsHandler,
  getPostHandler,
  likePostHandler,
} from './backend/controllers/PostController';
import {
  bookmarkPostHandler,
  editUserHandler,
  followUserHandler,
  getAllUsersHandler,
  getBookmarkPostsHandler,
  getUserHandler,
  removePostFromBookmarkHandler,
  unfollowUserHandler,
} from './backend/controllers/UserController';
import { posts } from './backend/db/posts';
import { users } from './backend/db/users';

export function makeServer({ environment = 'development' } = {}) {
  return new Server({
    serializers: {
      application: RestSerializer,
    },
    environment,
    // TODO: Use Relationships to have named relational Data
    models: {
      post: Model,
      user: Model,
    },

    // Runs on the start of the server
    seeds(server) {
      server.logging = false;
      users.forEach((item) =>
        server.create('user', {
          ...item,
          followers: [],
          following: [],
          bookmarks: [],
        }),
      );
      posts.forEach((item) => server.create('post', { ...item }));
    },

    routes() {
      this.namespace = 'api';
      // auth routes (public)
      this.post('/auth/signup', signupHandler.bind(this));
      this.post('/auth/login', loginHandler.bind(this));

      // post routes (public)
      this.get('/posts', getAllpostsHandler.bind(this));
      this.get('/posts/:postId', getPostHandler.bind(this));
      this.get('/posts/user/:username', getAllUserPostsHandler.bind(this));

      // post routes (private)
      this.post('/posts', createPostHandler.bind(this));
      this.delete('/posts/:postId', deletePostHandler.bind(this));
      this.post('/posts/edit/:postId', editPostHandler.bind(this));
      this.post('/posts/like/:postId', likePostHandler.bind(this));
      this.post('/posts/dislike/:postId', dislikePostHandler.bind(this));

      //post comments routes (public)
      this.get('/comments/:postId', getPostCommentsHandler.bind(this));

      //post comments routes (private)
      this.post('/comments/add/:postId', addPostCommentHandler.bind(this));
      this.post('/comments/edit/:postId/:commentId', editPostCommentHandler.bind(this));
      this.delete('/comments/delete/:postId/:commentId', deletePostCommentHandler.bind(this));
      this.post('/comments/upvote/:postId/:commentId', upvotePostCommentHandler.bind(this));
      this.post('/comments/downvote/:postId/:commentId', downvotePostCommentHandler.bind(this));

      // user routes (public)
      this.get('/users', getAllUsersHandler.bind(this));
      this.get('/users/:username', getUserHandler.bind(this));

      // user routes (private)
      this.post('users/edit', editUserHandler.bind(this));
      this.get('/users/bookmark', getBookmarkPostsHandler.bind(this));
      this.post('/users/bookmark/:postId/', bookmarkPostHandler.bind(this));
      this.post('/users/remove-bookmark/:postId/', removePostFromBookmarkHandler.bind(this));
      this.post('/users/follow/:followUserId/', followUserHandler.bind(this));
      this.post('/users/unfollow/:followUserId/', unfollowUserHandler.bind(this));
      this.passthrough();
      this.passthrough('https://api.cloudinary.com/v1_1/anujy0510/image/upload', ['post']);
    },
  });
}
